"use client";

import { usePathname } from "next/navigation";

interface ConditionalMainProps {
  children: React.ReactNode;
}

/**
 * Home hero is full-bleed under the fixed header; other routes keep top offset for header clearance.
 */
export function ConditionalMain({ children }: ConditionalMainProps): JSX.Element {
  const isHome = usePathname() === "/";

  return (
    <main
      className={`flex flex-1 flex-col ${
        isHome
          ? "bg-background pt-0 dark:bg-[#03050a]"
          : "relative z-10 bg-background/92 pt-32 dark:bg-[#03050a]/58"
      }`}
    >
      {children}
    </main>
  );
}
